import { Component } from '@angular/core';

@Component({
  selector: 'app-cp-10-30-09-17',
  standalone: true,
  imports: [],
  templateUrl: './cp-10-30-09-17.component.html',
  styleUrl: './cp-10-30-09-17.component.scss'
})
export class Cp10300917Component {

}
